export function selectCategoryName(category) {
    let categoryName = 'Hospitality';
    switch (category) {
        case 'Restaurants & Food':
        case 'Accommodation and Food Services':
            categoryName = 'Hospitality';
            break;

        case 'Manufacturing':
            categoryName = 'Manufacturing';
            break;

        case 'Retail':
        case 'Retail Trade': 
            categoryName = 'Retail';
            break;

        case 'Automotive & Boat' :
        case 'Retail Trade': 
            categoryName = 'Retail';
            break;

        case 'Agriculture':
        case 'Agriculture, Forestry, Fishing and Hunting':
            categoryName = 'Agriculture';
            break;

        case 'Service Businesses': 
        case 'Professional, Scientific and Technical Services':
            categoryName = 'Services';
            break;

        case 'Entertainment & Recreation': 
        case 'Arts, Entertainment and Recreation':
            categoryName = 'Entertainment';
            break;

        case 'Building & Construction': 
        case 'Construction':
            categoryName = 'Construction';
            break;

        case 'Transportation & Storage':
        case 'Transportation and Warehousing':
            categoryName = 'Logistics';
            break;

        case 'Wholesale & Distributors': 
        case 'Wholesale Trade':
            categoryName = 'Wholesale';
            break;

        case 'Real Estate, Rental and Leasing':
            categoryName = 'Real Estate';
            break;

        case 'Health Care and Social Assistance':
            categoryName = 'Health Care';
            break;

        case 'Educational Services':
            categoryName = 'Education';
            break;

        case 'Other Services (except Public Administration)':
            categoryName = 'Other Services';
            break;
            
        case 'Administrative, Support, Waste Management and Remediation Services':
            categoryName = 'Administrative';
            break;

        case 'Utilities':
            categoryName = 'Utilities';
            break;

        case 'Finance and Insurance': 
            categoryName = 'Finance';
                break;

        case 'Information': 
            categoryName = 'Information';
                break;

        case 'Mining, Quarrying, Oil and Gas Extraction':
            categoryName = 'Mining';
            break;

        default:
            categoryName = 'Hospitality';
    }
    return categoryName;
}